import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ConsultantDetails from "./ConsultantDetails";
import AppointmentCalendarView from "./AppoinmentCalendarView";

const ViewConsultant = () => {
  const { id } = useParams();
 
  return (
    <div className="d-md-flex d-block">
      <ConsultantDetails consultantid={id} />
      <div className="flex-grow-1">
        <AppointmentCalendarView consultantid={id} />
      </div>
    </div>
  );
};

export default ViewConsultant;
